import { Injectable } from '@angular/core';
import { ClientState } from 'src/app/_model/client-state';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { ClientStateDaoService } from '../client-state-dao.service';

// Constants
const CLIENTSTATE_KEY = 'state';

/**
 * DataAccessObject for Client states
 */
@Injectable()
export class ClientStateStorageDaoService implements ClientStateDaoService {
  // Lifecycle
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  // Public Functions
  public async saveState(state: ClientState): Promise<void> {
    await this.keyValueStorage.store(CLIENTSTATE_KEY, state);
  }

  public async loadState(): Promise<ClientState> {
    let obj = await this.keyValueStorage.load(CLIENTSTATE_KEY);
    return new ClientState(obj);
  }

  public async reset() {
    // Clientstate cannot be reset only cleared
    await this.clear();
  }

  public async clear() {
    await this.keyValueStorage.delete(CLIENTSTATE_KEY);
  }
}
